"use client";

/**
 * Sprint 5+ — ZAYA design system migration.
 *
 * Thin client wrapper around `next-themes` so the app shell can
 * provide a `class`-based dark/light toggle (the spec mandates dark
 * by default to match ZAYA PM's primary surface).
 *
 * `enableSystem={false}` — we don't want the trainee's system theme
 * to override the brand default. Trainers explicitly opt into light
 * via the theme switcher in the topbar.
 */
import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

type ThemeProviderProps = React.ComponentProps<typeof NextThemesProvider>;

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
